import ACTIONS from "../actions/ServicesActions";
import _ from "lodash";
import {populateFilterOptions} from "../../../common/utils/PopulateFilterOptions";
import {filterServices, listPageGlobalFilter} from "../../../common/utils/FilterFunctions";
import {setFilters} from "../../../common/utils/SetFilters";
import {SortFields} from "../constants/ServiceActionConstants";
import SortDirection from "../../../common/constants/SortDirection";

const initialState = {
    kyb_services: [],
    filtered_kyb_services: [],
    kybSortKey: SortFields.SERVICE_NAME,
    kybSortDirection: SortDirection.ASC,
    kybFilterOptions: {
        dpFilterOptions: [],
        countryOptions: [],
        statusOptions: [],
        subDPTypeOptions: [],
        verifiableElementsOptions: [],
        invoiceNameOptions: [],
    },
    kybFilters: {
        providerNameFilter: null,
        countryFilter: [],
        statusFilter: null,
        subDPTypeFilter: null,
        verifiableElementsFilter: null,
        invoiceNameFilter: null,
    },
    kyb_filtered_state: true,
    all_kyb_selected: false,
    some_kyb_selected: false,
    selected_kyb_services: [],
};

/**
 * Reducer to manage state relevant to the kyb-services collection.
 * */
const kybServicesReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Types.KYB_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_kyb_services = listPageGlobalFilter(action.payload, newState.kyb_services);

            return newState;
        }


        case ACTIONS.Types.TOGGLE_KYB_SORT: {
            let newState = _.cloneDeep(state);
            newState.kybSortDirection = newState.kybSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            newState.kybSortKey = action.payload;
            if (newState.kybSortDirection === SortDirection.ASC) {
                newState.filtered_kyb_services = _.sortBy(newState.filtered_kyb_services,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]);
            } else {
                newState.filtered_kyb_services = _.sortBy(newState.filtered_kyb_services,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
            }
            return newState;
        }


        case ACTIONS.Types.ALL_KYB_SELECTED: {
            let newState = _.cloneDeep(state);
            const selectedIds = action.payload.serviceIds;
            newState.all_kyb_selected = !newState.all_kyb_selected;
            newState.selected_kyb_services = action.payload.isSelected
                ? [...new Set([...selectedIds])]
                : newState.selected_kyb_services.filter(selectedServiceId =>
                    !newState.selected_kyb_services.includes(selectedServiceId));
            return newState
        }

        case ACTIONS.Types.SOME_KYB_SELECTED: {
            let newState = _.cloneDeep(state);
            const selectedId = [action.payload.serviceId];
            newState.selected_kyb_services = action.payload.isSelected
                ? [...new Set([...newState.selected_kyb_services, ...selectedId])]
                : newState.selected_kyb_services.filter(selectedServiceId =>
                    !selectedId.includes(selectedServiceId));
            newState.some_kyb_selected = newState.selected_kyb_services.length > 0 && !newState.all_kyb_selected
            return newState;
        }

        case ACTIONS.Types.LOAD_KYB_SERVICES: {
            let newState = _.cloneDeep(state);
            newState.kyb_services = action.payload;
            newState.filtered_kyb_services = newState.kyb_services;
            // split the string of country codes to an array.
            newState.filtered_kyb_services.forEach(service => {
                if (service.associated_countries !== null) {
                    service.associated_countries = service.associated_countries.split(",");
                }
                if (service.verifiable_elements !== null) {
                    service.verifiable_elements = service.verifiable_elements.split(",");
                }
            })
            newState.kybFilterOptions = populateFilterOptions(newState.kybFilterOptions, newState.kyb_services);
            newState.kyb_filtered_state = false;
            return newState;
        }

        case ACTIONS.Types.SET_KYB_FILTER: {
            let newState = _.cloneDeep(state);
            newState.kybFilters = setFilters(newState.kybFilters,
                action.payload.filterType, action.payload.filterOption);
            return newState;
        }

        case ACTIONS.Types.FILTER_KYB_SERVICES: {
            let newState = _.cloneDeep(state);
            newState.filtered_kyb_services = filterServices(newState.kybFilters, newState.kyb_services);
            newState.kyb_filtered_state = true;
            return newState;
        }

        default:
            return state;
    }
};

export default kybServicesReducer;
